import { Ticket } from '../../models';
import { GET_HELPDESK_TICKETS } from '../constants/helpdeskTicketsList';

// eslint-disable-next-line import/prefer-default-export
export const getHelpdeskTickets = (data) => {
  const convertedTickets = data.map((item) => {
    const { id, category, title, content, date } = item;
    return new Ticket(id, category, title, content, date);
  });
  return {
    type: GET_HELPDESK_TICKETS,
    payload: convertedTickets,
  };
};
